// Available CMS permissions that can be assigned to roles
export const CMS_PERMISSIONS = [
    // Dashboard
    { key: 'dashboard.view', label: 'View Dashboard', group: 'Dashboard' },

    // Trail Management
    { key: 'trails.view', label: 'View Trails', group: 'Trail' },
    { key: 'trails.create', label: 'Create Trails', group: 'Trail' },
    { key: 'trails.edit', label: 'Edit Trails', group: 'Trail' },
    { key: 'trails.delete', label: 'Delete Trails', group: 'Trail' },

    // Marathon Trail
    { key: 'marathon_trails.view', label: 'View Marathon Trails', group: 'Marathon Trail' },
    { key: 'marathon_trails.create', label: 'Create Marathon Trails', group: 'Marathon Trail' },
    { key: 'marathon_trails.edit', label: 'Edit Marathon Trails', group: 'Marathon Trail' },
    { key: 'marathon_trails.delete', label: 'Delete Marathon Trails', group: 'Marathon Trail' },

    // Stay
    { key: 'stay.view', label: 'View Stay Locations', group: 'Stay' },
    { key: 'stay.create', label: 'Create Stay Locations', group: 'Stay' },
    { key: 'stay.edit', label: 'Edit Stay Locations', group: 'Stay' },
    { key: 'stay.delete', label: 'Delete Stay Locations', group: 'Stay' },

    // Eat Local
    { key: 'eat_local.view', label: 'View Eat Local', group: 'Eat Local' },
    { key: 'eat_local.create', label: 'Create Eat Local', group: 'Eat Local' },
    { key: 'eat_local.edit', label: 'Edit Eat Local', group: 'Eat Local' },
    { key: 'eat_local.delete', label: 'Delete Eat Local', group: 'Eat Local' },

    // Challenges
    { key: 'challenges.view', label: 'View Challenges', group: 'Challenges' },
    { key: 'challenges.edit', label: 'Edit Challenges', group: 'Challenges' },

    // Reviews
    { key: 'reviews.view', label: 'View Reviews', group: 'Reviews' },
    { key: 'reviews.create', label: 'Create Reviews', group: 'Reviews' },
    { key: 'reviews.edit', label: 'Edit Reviews', group: 'Reviews' },
    { key: 'reviews.delete', label: 'Delete Reviews', group: 'Reviews' },

    // Photos
    { key: 'photos.view', label: 'View Photos', group: 'Photos' },
    { key: 'photos.create', label: 'Create Photos', group: 'Photos' },
    { key: 'photos.edit', label: 'Edit Photos', group: 'Photos' },
    { key: 'photos.delete', label: 'Delete Photos', group: 'Photos' },

    // Activities
    { key: 'activities.view', label: 'View Activities', group: 'Activities' },
    { key: 'activities.create', label: 'Create Activities', group: 'Activities' },
    { key: 'activities.edit', label: 'Edit Activities', group: 'Activities' },
    { key: 'activities.delete', label: 'Delete Activities', group: 'Activities' },

    // Ranking
    { key: 'ranking.view', label: 'View Ranking', group: 'Ranking' },

    // Membership
    { key: 'membership.view', label: 'View Memberships', group: 'Membership' },
    { key: 'membership.create', label: 'Create Memberships', group: 'Membership' },
    { key: 'membership.edit', label: 'Edit Memberships', group: 'Membership' },
    { key: 'membership.delete', label: 'Delete Memberships', group: 'Membership' },

    // ExoSeed
    { key: 'exoseed.view', label: 'View ExoSeed', group: 'ExoSeed' },
    { key: 'exoseed.create', label: 'Create ExoSeed', group: 'ExoSeed' },
    { key: 'exoseed.edit', label: 'Edit ExoSeed', group: 'ExoSeed' },
    { key: 'exoseed.delete', label: 'Delete ExoSeed', group: 'ExoSeed' },

    // Events
    { key: 'events.view', label: 'View Events', group: 'Events' },
    { key: 'events.create', label: 'Create Events', group: 'Events' },
    { key: 'events.edit', label: 'Edit Events', group: 'Events' },
    { key: 'events.delete', label: 'Delete Events', group: 'Events' },

    // Ticketing
    { key: 'tickets.view', label: 'View All Tickets', group: 'Ticketing' },
    { key: 'tickets.my_tickets', label: 'View My Tickets', group: 'Ticketing' },
    { key: 'tickets.edit', label: 'Edit Tickets', group: 'Ticketing' },

    // Crawl
    { key: 'crawl.view', label: 'View Crawl', group: 'Crawl' },
    { key: 'crawl.edit', label: 'Edit Crawl', group: 'Crawl' },

    // User Management
    { key: 'users.view', label: 'View Customers', group: 'Users' },
    { key: 'users.create', label: 'Create Customers', group: 'Users' },
    { key: 'users.edit', label: 'Edit Customers', group: 'Users' },
    { key: 'users.delete', label: 'Delete Customers', group: 'Users' },

    // Admin Management
    { key: 'admins.view', label: 'View Admins', group: 'Admins' },
    { key: 'admins.create', label: 'Create Admins', group: 'Admins' },
    { key: 'admins.edit', label: 'Edit Admins', group: 'Admins' },
    { key: 'admins.delete', label: 'Delete Admins', group: 'Admins' },

    // Role Management
    { key: 'roles.view', label: 'View Roles', group: 'Roles' },
    { key: 'roles.create', label: 'Create Roles', group: 'Roles' },
    { key: 'roles.edit', label: 'Edit Roles', group: 'Roles' },
    { key: 'roles.delete', label: 'Delete Roles', group: 'Roles' },

    // Settings
    { key: 'settings.ads', label: 'Manage Ads', group: 'Settings' },
    { key: 'settings.app_version', label: 'Manage App Version', group: 'Settings' },
    { key: 'settings.app_setting', label: 'Manage App Settings', group: 'Settings' },
    { key: 'settings.attributes', label: 'Manage Attributes', group: 'Settings' },
    { key: 'settings.notification', label: 'Manage Notifications', group: 'Settings' },
    { key: 'settings.gps', label: 'Manage GPS Settings', group: 'Settings' },
];

// Available languages for translation
export const AVAILABLE_LANGUAGES = [
    { code: 'vi', label: 'Vietnamese', flag: '🇻🇳' },
    { code: 'en', label: 'English', flag: '🇺🇸' },
    { code: 'ja', label: 'Japanese', flag: '🇯🇵' },
    { code: 'th', label: 'Thailand', flag: '🇹🇭' },
    { code: 'id', label: 'Indonesia', flag: '🇮🇩' },
    { code: 'ms', label: 'Malaysia', flag: '🇲🇾' },
    { code: 'ko', label: 'Korean', flag: '🇰🇷' },
    { code: 'zh', label: 'Chinese', flag: '🇨🇳' },
    { code: 'fr', label: 'French', flag: '🇫🇷' },
    { code: 'de', label: 'German', flag: '🇩🇪' },
    { code: 'es', label: 'Spanish', flag: '🇪🇸' },
];
